export const defaultCellStyle = {
    maxWidth: "200px",
    padding: "0.375rem",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
};
//# sourceMappingURL=defaultTableCellStyle.js.map